import React from 'react';
import * as Yup from "yup";
import styles from './SaleDetailsForm.module.scss';
import {ITicketDetailsWithTerms} from '../ticketDetailsForm';
import AbstractSaleDetailsForm
  from 'gui/components/editors/commons/editor/components/abstractSaleDetailsForm';
import FlightInfo
  from 'gui/pages/mainRouter/pages/ad/components/adFlight/components/firstStage/components/flightInfo/FlightInfo';
import {generateFlightTitle} from 'gui/pages/mainRouter/pages/ad/components/adFlight';

export interface ISaleDetails {
  askingPrice?: number;
  allowPurchaseOfSingleTickets?: boolean;
  currency?: number;
  commissionPercentage?: number;
}


interface ISaleDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  ticketDetails?: ITicketDetailsWithTerms;
  saleDetails?: ISaleDetails;
  setSubmitRef?: any;

  commonFormComponents?: any;
}

const yupSchema = Yup.object({
  askingPrice: Yup.number()
    .required("יש לבחור מחרי")
    .min(1, "מחיר מכירה צריך להיות גבוהה מ-1")
    .max(999999, "מכירה צריך להיות נמוך מ-999999"),
  allowPurchaseOfSingleTickets: Yup.boolean().required("יש לבחור כן או לא"),
  currency: Yup.number().min(1).max(10).required("יש לבחור מטבע"),
});

const SaleDetailsForm = (props: ISaleDetailsFormProps) => {
  return (<AbstractSaleDetailsForm
    {...props}
    currency={props.ticketDetails.currency}
    changePrice={props.ticketDetails.changePrice}
    valuePrice={props.ticketDetails.currentAirlineAllTicketsPrice}
    commonFormComponents={props.commonFormComponents}
    infoComponent={
      <FlightInfo product={props as any} className={styles.flightInfo} title={generateFlightTitle({product: props})}/>
    }
    setSubmitRef={props.setSubmitRef}
    saleDetails={props.saleDetails}
    onSubmit={props.onSubmit}
  />);
};


SaleDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  ticketDetails: {},
  saleDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};

export default React.memo(SaleDetailsForm);
